import { Module } from 'vuex';
import { IRootState, client } from '@/store';
import { IDocument, IPageParams, ICRUDResponse, IFileWrapper } from '@/models';

export interface IDocumentState {
  entities: Record<string, IDocument>;
  currentPage: number[];
  pageParams: Partial<IPageParams>;
}

export const document: Module<IDocumentState, IRootState> = {
  namespaced: true,
  state: {
    entities: {},
    currentPage: [],
    pageParams: {
      per_page: 15,
    },
  },
  actions: {
    getEntities({ commit }) {
      client
        .get<ICRUDResponse<IDocument[]>>('document')
        .then(({ data: { data, ...pageParams } }) => {
          commit('setEntities', data);
          commit('setPageParams', pageParams);
        });
    },
    getEntity({ commit }, id) {
      return client
        .get<ICRUDResponse<IDocument>>(`document/${id}`)
        .then(({ data }) => {
          commit('setEntities', [data]);
        });
    },
    createEntity({ dispatch }, entity: Omit<IDocument, 'id'>) {
      const data = new FormData();
      if(entity.name){
        data.append('name', entity.name);
      }
      data.append('creator_id', entity.creator_id.toString())
      entity.files.forEach((item) => {
        data.append('files[]', item.apiRepresentation as any || item);
      });
      return client.post('document', data).then(({ data }) => {
        dispatch('getEntities')
        return data
      });
    },
    deleteEntity({ dispatch }, entity: IDocument) {
      return client
        .delete(`document/${entity.id}`)
        .then(() => dispatch('getEntities'));
    },
    updateEntity({ dispatch }, entity: IDocument) {
      const data = new FormData();
      if(entity.name){
        data.append('name', entity.name);
      }
      data.append('_method', 'PATCH');
      data.append('creator_id', entity.creator_id.toString())
      entity.files.forEach((item) => {
        data.append('files[]', item.apiRepresentation as any || item);
      });
      return client
        .post(`document/${entity.id}`, data)
        .then(({ data }) => {
          dispatch('getEntities')
          return data
        });
    },
  },
  mutations: {
    setEntities(state, datum: IDocument | IDocument[]) {
      const entities = Array.isArray(datum) ? datum : [datum];
      state.entities = entities.map<IDocument>(entity => {
        entity.files = entity.files.map(file => {
          const dummyFile = new File([], file.name) as IFileWrapper;
          dummyFile.path = file.path;
          dummyFile.apiRepresentation = file;
          return dummyFile;
        });
        return entity;
      }).reduce(
        (acc, item) => ({ ...acc, [item.id]: item }),
        {},
      );
      state.currentPage = entities.map((entity) => entity.id);
    },
    setPageParams(state, pageParams: Omit<ICRUDResponse<IDocument[]>, 'data'>) {
      state.pageParams = pageParams;
    },
  },
  getters: {
    entitiesSlice({ currentPage, entities }) {
      return currentPage.map((id) => entities[id]);
    },
  },
};
